import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ObjectInspector } from 'react-inspector';

import { Spinner, ErrorMessage } from './base';

import './JqlConsole.scss';

const INITIAL_STATE = 0;
const RESULT_STATE = 1;
const BUSY_STATE = 2;
const ERROR_STATE = 3;

class JqlConsole extends Component {

  constructor(props, context) {
    super(props, context);
    this._handleEdit = this.handleEdit.bind(this);
    this._submitQuery = this.submitQuery.bind(this);

    // https://jira.atlassian.com/rest/api/2/search?jql=project=anerds%20and%20resolution=Duplicate
    this.state = {
      currentLine: 'project=PA',
      data: null,
      queryState: INITIAL_STATE,
      queryError: null,
    };
  }

  async submitQuery() {
    const jql = this.state.currentLine;
    const opts = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    try {
      this.setState({
        data: null,
        queryState: BUSY_STATE,
        queryError: null,
      });
      const response = await window.fetch(`/api/jql-query/${encodeURIComponent(jql)}`, opts);
      if (!response) {
        this.setState({
          queryState: ERROR_STATE,
          data: null,
          queryError: 'No response from server.',
        });
        return;
      }
      if (response.status < 200 || response.status >= 300) {
        this.setState({
          queryState: ERROR_STATE,
          data: null,
          queryError: `ERROR ${response.status} ${response.statusText}`,
        });
        return;
      }
      const input = await response.json();
      const {
        data = null,
        error = null,
      } = input;
      if (error) {
        this.setState({
          queryState: ERROR_STATE,
          data: null,
          queryError: error,
        });
      } else if (data) {
        this.setState({
          queryState: RESULT_STATE,
          data,
          queryError: null,
        });
      }
    } catch (e) {
      this.setState({
        queryState: ERROR_STATE,
        data: null,
        queryError: e.message ? e.message : e.toString(),
      });
    }
  }

  handleEdit(event) {
    this.setState({ currentLine: event.target.value });
  }

  render() {
    const bottomComponent = () => {
      if (this.state.queryState === INITIAL_STATE) {
        return <div />;
      }
      if (this.state.queryState === BUSY_STATE) {
        return <Spinner />;
      }
      if (this.state.queryState === ERROR_STATE) {
        console.log('typeof this.state.queryError', this.state.queryError);
        return <ErrorMessage error={this.state.queryError} />;
      }
      return <ObjectInspector theme="chromeDark" expandLevel={2} data={this.state.data} />;
    };

    return (
      <div className="JqlConsole">
        <h1>JIRA JQL CONSOLE</h1>
        <div className="inputComponents">
          <div className="label">JQL:</div>
          <input
            size="100"
            type="text"
            value={this.state.currentLine}
            onChange={this._handleEdit}
            onKeyUp={(e) => {
              if (e.keyCode === 13 && this.state.currentLine) {
                e.preventDefault();
                this._submitQuery();
              }
            }}
          />
          <button
            className="queryButton"
            disabled={this.state.queryState === BUSY_STATE}
            onClick={this._submitQuery} // eslint-disable-line no-underscore-dangle
          >
            RUN QUERY
          </button>
        </div>
        <div className="outputComponent">{ bottomComponent() }</div>
      </div>
    );
  }
}

JqlConsole.defaultProps = {
  theme: 'chromeDark',
  expandLevel: 2,
};

JqlConsole.propTypes = {
  theme: PropTypes.string,
  expandLevel: PropTypes.number,
};

export default JqlConsole;
